<template>
    <b-button
      type="button"
      size="sm"
      variant="success"
      v-on:click="resetPassword"
      :disabled="disabled"
    >
      <i class="fa fa-plus" ></i> Reset
    </b-button>
</template>
<script>
  import {RepositoryFactory} from "../../../services/repositories/RepositoryFactory";
  import router from "../../../router";

  export default {
    name: 'reset-password-button',
    props: {
      userId: {
        type: String,
        required: true,
      },
      newPassword: {
        type: String,
        required: true,
      },
      disabled: {
        type: Boolean,
        default: false,
      }
    },
    data() {
      return {
        resetHash: this.$route.query.resetHash
      }
    },
    methods: {
      resetPassword() {
        this.$emit('click')
        RepositoryFactory
          .get('user')
          .changePassword(this.userId, this.newPassword, this.resetHash)
          .then(
            () => (
              router.push({name: 'Login'})
            )
          )
          .catch(
            response => (
              this.$emit('error', response.data.errors)
            )
          )
      }
    }
  }
</script>
